import React, { useState } from 'react';
import UnitCard from '../searchApp/Components/UnitCard';
import ApartmentCard from '../searchApp/Components/ApartmentCard';

const App = ({ initialCards, type, cardType }) => {
  const [cards] = useState(initialCards);
  const [activeSearchType] = useState(
    'AsoFilters' === cardType ? 'aso' : 'rent'
  );

  return (
    <div className='flex justify-center flex-wrap'>
      {cards?.map((card) => {
        if ('units' === type) {
          return (
            <UnitCard
              key={card.post_id}
              data={card}
              searchType={activeSearchType}
            />
          );
        } else if ('apartments' === type) {
          return (
            <ApartmentCard
              key={card.post_id}
              data={card}
              searchType={activeSearchType}
            />
          );
        } else {
          return false;
        }
      })}
    </div>
  );
};

export default App;
